import React from 'react';
import { Provider } from '../../common/ComponentIdContext';
import { ComponentNameProvider } from '../../common/ComponentNameContext';
import ConstCommon from '../../common/Const';
import Tab from '../../common/tab';
import EventEmitter, {
  SHOW_GUEST_POPUP,
  TICKER_ADDED_TO_WL,
} from '../../helpers/EventEmitter';
import CoveredWarrant from './covered-warrant/CoveredWarrant';
import { I18n } from 'react-redux-i18n';
import SearchAdd from './SearchAdd';
import Filter from './Filter';
import Create from './summary/Create';
import { connect } from 'react-redux';
import {
  changeTab,
  fetchListNewsData,
  fetchMyWatchList,
  REDUCER_NAME,
  setDateRangeOption,
  subscribeRealtimeTickData,
  fetchListSummary,
} from './reducer';
import { includes } from 'lodash';
import moment from 'moment';
import TableIndex from './summary/TableIndex';
import Footer from '../../common/table/Footer';
import OrganizeColumnIndex from './summary/OrganizeColumnIndex';
import TableDerivative from './summary/TableDerivative';
import TableFundamental from './fundamental/Table';
import TablePerformance from './performance/Table';
import Technical from './technical/Technical';
import News from './news/News';
import PopupCalendar from './PopupCalendar';
import './index.scss';
import { ChanelConfig } from '../../../configs/GlobalConfig';
import ViewChart from './ViewChart';
import { Chart } from './chart';
import ConfirmDeletePopup from './summary/ConfirmDeletePopup';
import ConfirmCreatePopup from './summary/ConfirmCreatePopup';
import ScrollComponent from './../../common/ScrollComponent';
import { compose } from 'redux';
import withRealtime from './../../common/withRealtime';
import PreRender from './../../common/PreRender';
import PutThrough from './PutThrough';
import NotifySaveWatchList from './NoftifySaveWatchList';
import TimeRangeWrapper from '../../common/time-range-wrapper';
import { isNotLoginOrExpired } from '../../helpers/Common';
import AutoReloadOnFocusBlurComponent from '../../../core/loading/AutoReloadOnFocusBlur';

class WatchList extends AutoReloadOnFocusBlurComponent {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
    };
  }

  reload() {
    const { fetchMyWatchList } = this.props;
    fetchMyWatchList();
  }

  componentDidMount() {
    super.componentDidMount();
    const { fetchMyWatchList } = this.props;
    fetchMyWatchList();
    EventEmitter.subscribe(TICKER_ADDED_TO_WL, this.onTickerAdded);
  }

  componentDidUpdate(prevProps) {
    const { fetchMyWatchList } = this.props;
    if (prevProps.locale !== this.props.locale) {
      fetchMyWatchList();
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    EventEmitter.unsubscribe(TICKER_ADDED_TO_WL, this.onTickerAdded);
  }

  onTickerAdded = data => {
    const { watchListId, fetchMyWatchList } = this.props;
    if (watchListId === data.watchListId) {
      fetchMyWatchList();
    }
  };

  getTypeSearch = () => {
    const {
      currentTab,
      watchListId,
      currentDerivative,
      currentPutThrough,
    } = this.props;
    if (currentTab === 3) {
      if (
        watchListId === currentDerivative ||
        watchListId === currentPutThrough
      )
        return 'Add';
      return 'Search';
    }
    return 'Add';
  };

  renderFooter = () => {
    const {
      watchListId,
      currentTab,
      currentDerivative,
      currentPutThrough,
      viewChart,
    } = this.props;

    if (currentDerivative === watchListId) {
      return null;
    }

    return (
      ((!includes([2, 3, 4, 5], currentTab) && !viewChart) ||
        includes([currentPutThrough], watchListId)) && <Footer />
    );
  };

  renderBody = () => {
    const {
      currentMyIndex,
      currentDefaultIndex,
      currentIndustry,
      watchListId,
      currentTab,
      currentDerivative,
      currentPutThrough,
      currentCoveredWarrant,
      viewChart,
    } = this.props;

    if (currentCoveredWarrant === watchListId) {
      return <CoveredWarrant />;
    }

    if (watchListId === currentDerivative) {
      return <TableDerivative />;
    }

    if (watchListId === currentPutThrough) {
      return <PutThrough />;
    }

    if (
      includes(
        [currentMyIndex, currentDefaultIndex, currentIndustry],
        watchListId,
      )
    ) {
      if (viewChart && currentTab === 1) {
        return <Chart />;
      }

      switch (currentTab) {
        case 1:
          return (
            <TableIndex isShowDeleteIcon={watchListId === currentMyIndex} />
          );

        case 2:
          return (
            <TableFundamental
              isShowDeleteIcon={watchListId === currentMyIndex}
            />
          );
        case 3:
          return <News />;
        case 4:
          return <Technical />;
        case 5:
          return (
            <TablePerformance
              isShowDeleteIcon={watchListId === currentMyIndex}
            />
          );
        default:
          return null;
      }
    }
  };

  renderTab = () => {
    const {
      currentMyIndex,
      currentDefaultIndex,
      currentIndustry,
      watchListId,
      currentTab,
      changeTab,
    } = this.props;

    return (
      <div>
        {includes(
          [currentMyIndex, currentDefaultIndex, currentIndustry],
          watchListId,
        ) && (
          <Tab
            currentTab={currentTab}
            listTab="watchListCommon.tab"
            changeTab={changeTab}
          />
        )}
      </div>
    );
  };

  renderRightTab = () => {
    const {
      currentMyIndex,
      currentDefaultIndex,
      currentIndustry,
      watchListId,
      currentTab,
      user,
    } = this.props;

    if (
      includes(
        [currentMyIndex, currentDefaultIndex, currentIndustry],
        watchListId,
      ) &&
      currentTab === 1
    ) {
      const isDisable = isNotLoginOrExpired(user);
      const extraStyle = isDisable ? { pointerEvents: 'none' } : {};
      const onLockClick = () => {
        if (isDisable) {
          EventEmitter.dispatch(SHOW_GUEST_POPUP);
        }
      };

      return (
        <div style={{ cursor: 'pointer' }} onClick={onLockClick}>
          <div
            style={extraStyle}
            className="group-button-wat group-btn-right text-right pr-0 text-nowrap"
          >
            <ViewChart />
            <Create />
            <OrganizeColumnIndex />
          </div>
        </div>
      );
    }
  };

  renderListFilter = () => {
    const {
      currentMyIndex,
      watchListId,
      currentTab,
      dateRangeOption,
      isFetching,
      currentCoveredWarrant,
    } = this.props;

    return (
      <div className="list-filter">
        <SearchAdd
          disabled={
            (watchListId !== currentMyIndex &&
              currentTab !== 3 &&
              currentCoveredWarrant !== watchListId) ||
            isFetching
          }
          typeSearch={this.getTypeSearch()}
          dateRangeOption={dateRangeOption}
          isBelongToWatchList
        />
        <Filter />
      </div>
    );
  };

  resetDateRangeFilter = () => {
    const { setDateRangeOption, fetchListNewsData } = this.props;
    setDateRangeOption(null, null);
    fetchListNewsData({ FromDate: null, ToDate: null });
  };

  renderCalendar = () => {
    const {
      currentMyIndex,
      currentDefaultIndex,
      currentIndustry,
      watchListId,
      currentTab,
      setDateRangeOption,
      dateRangeOption,
      fetchListNewsData,
      i18n,
    } = this.props;
    moment.locale(i18n.locale);
    const dateFormat =
      i18n.locale === 'en'
        ? 'dddd, MMMM DD, YYYY'
        : 'dddd, ngày DD, MMMM, nă\\m YYYY';

    return (
      currentTab === 3 &&
      includes(
        [currentMyIndex, currentDefaultIndex, currentIndustry],
        watchListId,
      ) && (
        <div className="d-flex mb-10 align-items-center justify-content-between">
          <div>
            {dateRangeOption.FromDate && (
              <TimeRangeWrapper onClickCloseButton={this.resetDateRangeFilter}>
                <div className="date-range-title d-flex">
                  <div className="date-range-title--sub-text">
                    {I18n.t('watchListCommon.from')}
                  </div>
                  <div className="date-range-title--main-text">{`${moment(
                    dateRangeOption.FromDate,
                  ).format(dateFormat)}`}</div>
                  <div className="date-range-title--sub-text">
                    {I18n.t('watchListCommon.to')}
                  </div>
                  <div className="date-range-title--main-text">{`${moment(
                    dateRangeOption.ToDate,
                  ).format(dateFormat)}`}</div>
                </div>
              </TimeRangeWrapper>
            )}
          </div>
          <div
            style={{
              position: 'relative',
              width: '100%',
              textAlign: 'right',
            }}
          >
            <div className="d-flex float-right Calendar-right">
              <PopupCalendar
                isDateSelected={
                  dateRangeOption.FromDate || dateRangeOption.ToDate
                }
                setDateRangeOption={setDateRangeOption}
                fetchListNewsData={fetchListNewsData}
                FromDate={dateRangeOption.FromDate}
                ToDate={dateRangeOption.ToDate}
              />
            </div>
          </div>
        </div>
      )
    );
  };

  renderTabAndRightTab = () => {
    const { watchListId, currentDerivative, currentPutThrough } = this.props;

    return (
      !includes([currentDerivative, currentPutThrough], watchListId) && (
        <div className="d-flex mt-10 w-100 ml-0 mr-0 justify-content-between">
          {this.renderTab()}
          {this.renderRightTab()}
        </div>
      )
    );
  };

  render() {
    const { viewChart, currentTab, id } = this.props;
    return (
      <PreRender {...this.props}>
        <Provider value={id}>
          <ComponentNameProvider value={ConstCommon.listComponent.Watchlist}>
            <NotifySaveWatchList />
            <div className={`watchlist-wrapper h-100`}>
              <ConfirmDeletePopup />
              <ConfirmCreatePopup />
              <ScrollComponent>
                <div
                  className={`top-nav d-flex flex-column ${
                    viewChart && currentTab === 1 ? '' : 'h-100'
                  }`}
                >
                  <div
                    className={`px-20 pt-8 ${
                      viewChart && currentTab === 1 ? 'sticky' : ''
                    }`}
                  >
                    <div className="w-100">{this.renderListFilter()}</div>
                    {this.renderTabAndRightTab()}
                    {this.renderCalendar()}
                  </div>
                  <div className="tab-content d-flex flex-fill">
                    <div className="tab-pane active d-flex flex-fill flex-column">
                      {this.renderBody()}
                      <div className="pl-20 pr-20">{this.renderFooter()}</div>
                    </div>
                  </div>
                </div>
              </ScrollComponent>
            </div>
          </ComponentNameProvider>
        </Provider>
      </PreRender>
    );
  }
}

const mapStateToProps = state => {
  return {
    locale: state.i18n.locale,
    i18n: state.i18n,
    currentTab: state[REDUCER_NAME].currentTab,
    currentMyIndex: state[REDUCER_NAME].currentMyIndex,
    currentDefaultIndex: state[REDUCER_NAME].currentDefaultIndex,
    currentIndustry: state[REDUCER_NAME].currentIndustry,
    currentDerivative: state[REDUCER_NAME].currentDerivative,
    currentCoveredWarrant: state[REDUCER_NAME].currentCoveredWarrant,
    currentPutThrough: state[REDUCER_NAME].currentPutThrough,
    watchListId: state[REDUCER_NAME].watchListId,
    dateRangeOption: state[REDUCER_NAME].dateRangeOption,
    viewChart: state[REDUCER_NAME].viewChart,
    isFetching: state[REDUCER_NAME].isFetching,
    user: state.userInfo,
  };
};

const mapDispatchToProps = {
  changeTab,
  fetchMyWatchList,
  setDateRangeOption,
  fetchListNewsData,
  subscribeRealtimeTickData,
  fetchListSummary,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withRealtime(ChanelConfig.TickChanel, 'subscribeRealtimeTickData'),
)(WatchList);
